module.exports = __webpack_public_path__ + "static/media/settingIcon.7eef0b33.png";